import axios from "axios";
import React, { useEffect, useState } from "react";
import { ManyFileInput } from "../mostlyUsed/mainComponents";

type HesabfaProduct = {
  Barcode: string;
  Code: string;
};

type DiscountItem = {
  barcode: string;
  title: string;
  type: number;
  percent: number;
  validFrom: string;
  validTo: string;
  productCode: string;
};

const DiscountBuilder = () => {
  const [FileDatas, setFileDatas] = useState<
    { hesabfa: Record<string, any[]> } | undefined
  >();
  const [discountTitle, setDiscountTitle] = useState("");
  const [validFrom, setValidFrom] = useState("");
  const [validTo, setValidTo] = useState("");

  useEffect(() => {
    console.log("FileDatas: ", FileDatas);
  }, [FileDatas]);
  useEffect(() => {
    getAllProucts();
  }, []);
  const getAllProucts = async (): Promise<HesabfaProduct[] | undefined> => {
    const res = await axios.post(
      "https://api.hesabfa.com/v1/item/GetQuantity",
      {
        apiKey: "E62BNpYDHmn1K8JFNJG24jDSpTE9ktBP",
        loginToken:
          "3849304732a5e3cfd84a908ffd0b8c1c4e44c804df3692627b127d3f5638d3791105a1df1ddd2f00cb6bf2f36c3d3827",
      },
    );
    if (res?.data?.Result) {
      return res.data.Result;
    }
  };

  const addBunchDiscount = async (items: DiscountItem[]) => {
    const res = await axios.post(
      "https://api.hesabfa.com/v1/disCountItem/batchSave",
      {
        apiKey: "E62BNpYDHmn1K8JFNJG24jDSpTE9ktBP",
        loginToken:
          "3849304732a5e3cfd84a908ffd0b8c1c4e44c804df3692627b127d3f5638d3791105a1df1ddd2f00cb6bf2f36c3d3827",
        items: items,
      },
    );
    console.log("res: ", res);
  };

  const submit = async () => {
    if (!discountTitle || !validFrom || !validTo) {
      alert("لطفا عنوان تخفیف و تاریخ شروع و پایان را وارد کنید");
      return;
    }

    const allProducts = await getAllProucts();
    console.log("allProducts: ", allProducts);

    let finalData: DiscountItem[] = [];
    console.log("FileDatas: ", FileDatas);

    if (FileDatas?.hesabfa && allProducts) {
      for (let genderSection of Object.values(FileDatas.hesabfa)) {
        console.log("genderSection: ", genderSection);
        for (let item = 0; item < genderSection.length; item++) {
          for (let size = 3; size <= genderSection[0].length; size++) {
            const barcode =
              String(genderSection[item][1]) + String(genderSection[0][size]);
            // console.log("barcode: ", genderSection[item]);

            const code = allProducts.filter(
              (e: HesabfaProduct) => e.Barcode === barcode,
            )[0];
            console.log("code: ", genderSection[item]);

            if (
              item !== 0 &&
              genderSection[item][1] &&
              genderSection[0][size] &&
              code
            ) {
              finalData.push({
                barcode: barcode,
                title: discountTitle,
                type: 3,
                percent: genderSection[item][2] * 100,
                validFrom: `${validFrom}T00:00:01`,
                validTo: `${validTo}T23:59:59`,
                productCode: code.Code,
              });
            }
          }
        }
      }
    }
    console.log("finalData: ", finalData);
    addBunchDiscount(finalData);
  };

  return (
    <div className="mainComponent">
      <ManyFileInput
        title="فایل تخفیف"
        fileName="hesabfa"
        contextData={setFileDatas}
        digikala={null}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          alignItems: "center",
          marginTop: 16,
        }}
      >
        <label>
          عنوان تخفیف
          <input
            type="text"
            value={discountTitle}
            onChange={(e) => setDiscountTitle(e.target.value)}
            placeholder="فروش ویژه تابستانی"
          />
        </label>
        <label>
          از تاریخ
          <input
            type="date"
            value={validFrom}
            onChange={(e) => setValidFrom(e.target.value)}
          />
        </label>
        <label>
          تا تاریخ
          <input
            type="date"
            value={validTo}
            onChange={(e) => setValidTo(e.target.value)}
          />
        </label>
      </div>
      <div>
        <button onClick={submit}>تایید</button>
      </div>
    </div>
  );
};
export default DiscountBuilder;
